import React from 'react';

// retry wrapper needs to know the interval to disable auto-retry if it's greater than 3 months
// since interval is global to a page in most cases, use context to avoid passing it as a prop everywhere
interface RetryContextType {
  interval?: null | { from: any, to: any };
}

const RetryContext = React.createContext<RetryContextType>({ interval: null});

export default RetryContext;
